import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import type { PersonalAssistantManagementComponent } from '../personal-assistant-management.component';
import { AssistantCreateWizardComponent } from './assistant-create-wizard.component';

@Component({
  selector: 'assistant-mine-view',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzCardModule,
    NzButtonModule,
    NzInputModule,
    NzSelectModule,
    NzSpinModule,
    NzTagModule,
    NzIconModule,
    NzEmptyModule,
    I18nPipe,
    TestIdDirective,
    AssistantCreateWizardComponent
  ],
  templateUrl: './assistant-mine-view.component.html',
  styleUrls: ['./assistant-mine-view.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AssistantMineViewComponent {
  @Input({ required: true }) vm!: PersonalAssistantManagementComponent;
}
